/*eslint-disable*/

import OccupationCard from "components/common/Card/OccupationCard";
import { useAppSelector } from "store/hooks";
import { getCareerTabData } from "store/slices";
import { useSwiperSlide } from "swiper/react";

const Occupation = ({ item, onClick, idx }) => {
  const { isActive } = useSwiperSlide();
  const { activeCareersSliders } = useAppSelector(getCareerTabData);

  const subCarousel = !!(idx !== undefined && idx > 0);

  let isOrange;
  if (idx !== undefined && activeCareersSliders) {
    isOrange =
      isActive && idx <= parseInt(Object.keys(activeCareersSliders)[0]);
  }

  return (
    <>
      <OccupationCard
        idx={idx}
        item={item}
        className={`
        ${
          isOrange &&
          idx < parseInt(Object.keys(activeCareersSliders)[0]) &&
          "bg-opacity-70"
        }
        `}
        onClick={onClick}
        subCarousel={subCarousel}
        isOrange={isOrange}
      />
    </>
  );
};

export default Occupation;
